import { PerfilResponse } from "./perfilResponse"
export const PERILS_GET = 'PERILS_GET'

export interface PerfilState {
    Perfils: PerfilResponse[] | undefined,
}

export interface PerfilsAction {
    type: typeof PERILS_GET,
    payload: PerfilResponse[]
}

export type PerfilsActionTypes = PerfilsAction